import { render, staticRenderFns } from "./weekNavigator.vue?vue&type=template&id=7a34565b"
import script from "./weekNavigator.vue?vue&type=script&lang=js"
export * from "./weekNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports